module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tableWrap"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('span', {
    staticClass: "back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', [_vm._v(" ")]), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "mx"
  }, [_vm._v("BU罚单明细")]), _vm._v(" "), _c('p', {
    staticClass: "select"
  }, [_c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.datePick_start),
      callback: function($$v) {
        _vm.datePick_start = $$v
      },
      expression: "datePick_start"
    }
  }), _vm._v(" "), _c('small', [_vm._v("~")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.datePick_end),
      callback: function($$v) {
        _vm.datePick_end = $$v
      },
      expression: "datePick_end"
    }
  }), _vm._v(" "), _c('span', [_vm._v("罚单类型：")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.typeId),
      callback: function($$v) {
        _vm.typeId = $$v
      },
      expression: "typeId"
    }
  }, _vm._l((_vm.ticket_type), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.ticket_name
      }
    })
  })), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }, [_vm._v("查询")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-main"
  }, [_vm._m(0), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "main-wrap"
  }, [_vm._l((_vm.dataList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "main-item"
    }, [_c('div', [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("justDate")(item.created_at)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("cycleStr")(item)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.ticket_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.currency_name + item.ticket_amount))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.remark
      }
    }, [_vm._v(_vm._s(item.remark))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.dataList
    }
  })], 2)], 1), _vm._v(" "), _c('z-pagination', {
    attrs: {
      "data": _vm.data
    },
    on: {
      "getPage": _vm.search
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-head"
  }, [_c('div', [_vm._v("罚单编号")]), _vm._v(" "), _c('div', [_vm._v("罚单日期")]), _vm._v(" "), _c('div', [_vm._v("周期")]), _vm._v(" "), _c('div', [_vm._v("罚单类型")]), _vm._v(" "), _c('div', [_vm._v("金额(币)")]), _vm._v(" "), _c('div', [_vm._v("处罚原因")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-85a0daf4!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/buManage/page-ticketTable.vue
// module id = 771
// module chunks = 1